// One-shot visit ping. Calls the Edge Function once per browser tab.
// Rendered as a component (returns null) so it lives in the tree
// cleanly without React state.

import { recordVisit } from "@/entities/visit";
import { useTelegramStore } from "@/shared/store/telegram";

const STORAGE_KEY = "eurostyle_mini_app_visit_sent";

function alreadySent(): boolean {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") return true;
    sessionStorage.setItem(STORAGE_KEY, "1");
    return false;
  } catch {
    if (import.meta.env.DEV) console.warn("[visit] sessionStorage access failed");
    return false;
  }
}

const SKIP = alreadySent();

if (!SKIP) {
  const { webApp } = useTelegramStore.getState();
  void recordVisit({
    tg_id: webApp?.initDataUnsafe?.user?.id ?? 0,
    path: typeof location !== "undefined" ? location.pathname : "",
  });
  webApp?.ready?.();
  webApp?.expand?.();
}

import type { JSX } from "react";

export function VisitPing(): JSX.Element | null {
  return null;
}
